<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const nodeTypes = [
  {
    type: 'trigger',
    icon: 'i-lucide-zap',
    color: 'n-blue',
    bgClass: 'bg-n-blue-1 dark:bg-n-blue-2',
    textClass: 'text-n-blue-11',
    borderClass: 'hover:border-n-blue-5',
  },
  {
    type: 'message',
    icon: 'i-lucide-message-square',
    color: 'n-green',
    bgClass: 'bg-n-green-1 dark:bg-n-green-2',
    textClass: 'text-n-green-11',
    borderClass: 'hover:border-n-green-5',
  },
  {
    type: 'block',
    icon: 'i-lucide-layout-grid',
    color: 'n-indigo',
    bgClass: 'bg-n-indigo-1 dark:bg-n-indigo-2',
    textClass: 'text-n-indigo-11',
    borderClass: 'hover:border-n-indigo-5',
  },
  {
    type: 'data_collection',
    icon: 'i-lucide-clipboard-list',
    color: 'n-violet',
    bgClass: 'bg-n-violet-1 dark:bg-n-violet-2',
    textClass: 'text-n-violet-11',
    borderClass: 'hover:border-n-violet-5',
  },
  {
    type: 'condition',
    icon: 'i-lucide-git-branch',
    color: 'n-amber',
    bgClass: 'bg-n-amber-1 dark:bg-n-amber-2',
    textClass: 'text-n-amber-11',
    borderClass: 'hover:border-n-amber-5',
  },
  {
    type: 'action',
    icon: 'i-lucide-settings',
    color: 'n-violet',
    bgClass: 'bg-n-violet-1 dark:bg-n-violet-2',
    textClass: 'text-n-violet-11',
    borderClass: 'hover:border-n-violet-5',
  },
  {
    type: 'delay',
    icon: 'i-lucide-clock',
    color: 'n-amber',
    bgClass: 'bg-n-amber-1 dark:bg-n-amber-2',
    textClass: 'text-n-amber-11',
    borderClass: 'hover:border-n-amber-5',
  },
  {
    type: 'group',
    icon: 'i-lucide-box',
    color: 'n-slate',
    bgClass: 'bg-n-slate-2 dark:bg-n-slate-3',
    textClass: 'text-n-slate-11',
    borderClass: 'hover:border-n-slate-5',
  },
];

const onDragStart = (event, type) => {
  if (!event.dataTransfer) return;
  event.dataTransfer.setData('text/plain', type);
  event.dataTransfer.effectAllowed = 'move';
};
</script>

<template>
  <div class="w-full flex flex-col p-0 gap-2">
    <h3 class="text-xs font-semibold uppercase text-n-slate-11 mb-2">
      {{ t('FLOW_BUILDER.SIDEBAR.TITLE') }}
    </h3>
    <div class="grid grid-cols-2 gap-2">
      <div
        v-for="node in nodeTypes"
        :key="node.type"
        class="flex flex-col items-center gap-2 p-3 rounded-xl border border-n-weak dark:border-n-strong cursor-grab hover:shadow-md transition-all"
        :class="node.borderClass"
        draggable="true"
        @dragstart="onDragStart($event, node.type)"
      >
        <div
          class="w-10 h-10 rounded-xl flex items-center justify-center"
          :class="node.bgClass"
        >
          <span :class="[node.icon, node.textClass]" class="text-xl" />
        </div>
        <span class="text-xs font-medium text-n-slate-12 text-center">
          {{ t(`FLOW_BUILDER.SIDEBAR.${node.type.toUpperCase()}`) }}
        </span>
      </div>
    </div>
  </div>
</template>
